import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import MuiDialog from '@mui/material/Dialog';

export const StyledDialog = styled(MuiDialog)(
  () => css`
    &.question-dialog {
      .MuiDialog-paper {
        min-width: 425px;
        padding: 20px 0;
        padding-bottom: 16px !important;
      }

      .MuiDialogContent-root {
        padding: 4px 24px 8px;
      }

      .MuiDialogActions-root {
        justify-content: space-evenly;
      }

      .question-dialog-actions {
        flex-wrap: wrap;
        margin: 0 24px;

        button {
          min-width: 140px;
          margin: 8px;
        }
      }
    }

    @media (max-width: 600px) {
      &.question-dialog {
        .MuiDialog-paper {
          min-width: 246px;
        }
      }
    }

    @media (max-width: 500px) {
      &.question-dialog {
        .MuiDialog-paper {
          min-width: 90%;
        }
      }
    }
  `
);
